<template>
    <div class="home">
        <div class="date_box">
            <div class="one">
                <img  class="photo" v-lazy="data.photo" alt="">

                <div>
                    <div class="name">{{ data.dispname }}</div>
                    <div class="fee_box">费用<span class="fee">￥{{ data.fee }}</span></div>
                </div>
            </div>


            <div class="bg_box">

                <div class="info_item">
                    <div>预约类型：</div><span>{{ data.apptypename }}</span>
                </div>
                <div class="info_item">
                    <div>就诊诊所：</div><span>{{ data.clinicname }}</span>
                </div>
                <div class="info_item">
                    <div>预约时间：</div><span>{{ data.appointmenttime }}</span>
                </div>

                <van-cell style="padding: 5px 0px;"
                          :border="false"
                          is-link title="就诊诊室："
                          :value="roomname"
                          @click="show = true;setempty=true" />

                <div class="info_item">
                  <div>放号号数：</div>
                  <van-field
                      v-model="appcount"
                      type="number"
                      input-align="left"
                      style = "padding: 0 5px; border: 1px solid #ccc; border-radius: 4px;"
                  />
                </div>
            </div>


            <div class="flex">
                 <van-button  round block @click="sub()" :loading="loading_bt">确认修改</van-button>
            </div>

        </div>


        <van-dialog v-model="show" @confirm="confirm">
            <van-sticky :offset-top="0">
                <div class="title">
                     <div>选择诊室</div>
                </div>
                <van-icon class="close_icon" name="cross"  @click="()=>{show=false;setempty = false}"  />
            </van-sticky>
            <div class="room_list">
              <van-radio-group v-model="roomid">
                <van-cell-group>
                  <van-cell
                      v-for="item in data.roomlist"
                      :key="item.roomid"
                      clickable
                      @click="roomid = item.roomid"
                  >
                    <template #title>
                      {{ item.roomname }}
                    </template>

                    <template #right-icon>
                      <van-radio :name="item.roomid" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
        </van-dialog>

    </div>
</template>
<script>
import {wxappointmentplandetail, wxconfirmappointment, wxconfirmeditplan, wxsendpaynotice} from '@/api/medical'
import { mapGetters } from 'vuex'
import { Toast,Lazyload } from 'vant';
import Vue from 'vue';
import errorImg from '@/assets/医生头像.png'
Vue.use(Lazyload, {
        lazyComponent: true,
        loading: "https://yz.iyzzy.com/icon/loading.gif",
        error: errorImg
    });
export default {
    components: {  },
    computed: {
        ...mapGetters([
            'username', 'clinicid', 'openid'
        ])
    },
    data() {
        return {
            data: {},
            planid: 0,
            show: false,
            customername: '',
            customerid: '',
            userid: '',
            show_info: false,
            loading_bt: false,
            checked:0,
            roomid:'',
            roomname:'',
            appcount:'',
            setempty:true
        }
    },
    created() {
        this.$store.dispatch('hideOrShowNav', false)
        this.planid = this.$route.query.planid || ''
        this.getPlan()
    },

    methods: {
        getPlan() {
            let data = { username: this.username, planid: this.planid }
            wxappointmentplandetail(data).then(response =>{
              this.data = response.response_body
              this.roomid = String(this.data.roomid)
              this.roomname = this.data.roomname
              this.appcount = this.data.totalnum
            })
        },
        confirm(){
          this.setempty = true

          let room = this.data.roomlist.find(r => r.roomid == this.roomid)

          if(room){
            this.roomid = room.roomid
            this.roomname = room.roomname
          }
        },
        sub() {

            if(this.roomid==''){
                Toast.fail('请选择诊室');
                return
            }
            if(this.appcount==''){
              Toast.fail('请填写放号数');
              return
            }
            let sub_data = {
                planid: this.planid,
                roomid: this.roomid,
                appcount: this.appcount,

            }
            this.$dialog.confirm({
                title: null,
                message: "是否确认修改",
            }).then(() => {
                this.loading_bt = true
                wxconfirmeditplan(sub_data).then(response => {
                    this.loading_bt = false
                  if(response.response_body.flag == '1'){
                      Toast.success('修改成功');
                      this.goBack();
                  }else{
                    Toast.fail(response.response_body.msg);
                  }
                }).catch(() => {
                    this.loading_bt = false
                    Toast.fail('修改失败');
                    this.goBack();
                });
            })
        },
        goBack(){
          setTimeout(()=>{
            this.$router.go(-1)
            this.$store.dispatch('changeIsRefresh', '2')
          },2000)
        }

    }
}

</script>
<style lang="scss" scoped>
.home {
    padding: 15px;
    display: block;
    background: rgb(246, 246, 244);
    height: 100vh;
    overflow:auto;

    .one {
        display: flex;
    }

    .name {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }

    .tab_box {
        display: flex;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        overflow: hidden;
        width: 100%;
        margin-top: 10px;
    }

    .tab_item {
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #c2c0b9;
        color: #fff;
    }

    .fee {
        width: 100px;
        text-align: end;
        color: rgb(207, 140, 87);
    }

    .photo {
        width: 2rem;
        height: 2.5rem;
        border-radius: 10px;
        margin-right: 10px;
    }

    .bg_box {
        background-color: #fff;
        border-radius: 10px;
        padding: 5px 15px;
        margin-top: 15px;
        margin-bottom: 15px;

        :deep .van-cell__title{
          flex:unset;
          min-width: 80px;
        }
        :deep .van-cell__value{
          text-align: left;
          color: #000;
        }
    }

    .iconsanjiaoyou {
        font-size: 26px;
        width: 15px;
    }

    .intro {
        color: #999995 !important;
        white-space: pre-wrap;
        line-height: 0.55rem;
        word-break:break-all
    }

    .info_item {
        display: flex;
        color: #333;
        line-height: 24px;
        padding: 5px 0px;

        div {
            min-width: 80px;
        }

        span {
            color: #999995;
        }
    }

    .iconsanjiaoyou {
        font-size: 26px;
        width: 15px;
    }

    .info_l {
        color: rgb(207, 140, 87) !important;
    }

    h3 {
        margin-top: 10px;
        margin-bottom: 5px;
    }

    .cell_box {
        margin-bottom: 15px;
    }

    .dialog_box {
        padding: 10px 15px;

        img {
            width: 100%;
        }
    }


    :deep .van-dialog__content {
        max-height: 450px;
        overflow: auto;
    }

    :deep .van-dialog {
        width: 90%;
    }

    :deep .left {
        width: unset !important;
        display: flex;
    }

    :deep .right {
        width: unset !important;
    }

    :deep .treat_main_list {
        width: 100%;

        .van-radio {
            overflow: visible;

        }
    }

    :deep .van-radio {
        display: flex;
    }

    :deep .btnimg {
        display: none;
    }

    :deep .detail_info {
        display: none !important;
    }

    :deep .van-dialog__header {
        padding: 10px 0px !important;
    }

    :deep .van-cell {
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    :deep .van-icon {
        height: unset !important;
    }

    :deep .van-radio__icon {
        height: 1.1rem;
    }
    :deep .van-button--round{
        background-color: #CF8C57;
        width: 150px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        color: #fff;border-radius: 21px;
    }

    .flex{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .fee_box{
        margin-top: 1rem;
    }
    :deep .text-overflow{
        max-width: 3rem;
        display: block !important;

    }
    :deep .treat_main_list{
        margin-bottom: 0;
    }
    :deep .keyword_input{
        .van-sticky--fixed{
            top: 41px;
            z-index: 1;
            margin: 0px 4px;
        }
    }
    .title{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        padding: 10px 10px;

    }
    .close_icon{
            color: #969799;
            position: absolute !important;
            top: 11px;
            right: 13px;
            font-size: 20px;
        }

}</style>
